import styled, { css } from 'styled-components';
import Image from 'next/image';
import { rem } from '~/src/helpers/rem-converter.helper';
import { MAX_1279, MAX_1365, MAX_767 } from '~/src/styles/tokens/break-points';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';
import MainButton from '~/src/components/form-components/main-button/main-button';
import { Z_INDEX } from '~/src/styles/tokens/z-index';

const paddingButtonStyles = css`
    padding: ${rem(10)} ${rem(24)};
`;

const newLeadButtonStyles = css`
    background-color: ${COLORS.controlsLightSecondaryActive};
    border: 2px solid ${COLORS.controlsLightSecondaryActive};
`;

const zIndexStyles = css`
    z-index: ${Z_INDEX.level1};
`;

const buttonMobileStyles = css`
    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            width: 100%;
        `,
    )};
`;

export const AboutProductBannerContainer = styled.div<{ bannerGradient: string }>`
    position: relative;
    width: 100%;
    min-height: ${rem(236)};
    max-height: fit-content;
    flex-direction: column;
    flex-wrap: nowrap;
    border-radius: ${BORDER_RADIUS.biggest20};
    padding: ${rem(40)};
    background-image: ${(p) => p.bannerGradient};
    justify-content: center;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            border-radius: ${BORDER_RADIUS.zero};
            height: fit-content;
            padding: ${rem(20)} ${rem(40)} ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: ${rem(20)} ${rem(20)} ${rem(40)};
            height: auto;
        `,
    )};
`;

export const ImageContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto ${rem(40)} auto auto;
    width: ${rem(300)};
    height: ${rem(200)};
`;

export const AboutProductBannerContent = styled.div<{ width: number; }>`
    flex-direction: column;
    max-width: ${(p) => rem(p.width)};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: 100%;
            height: fit-content;
        `,
    )};
`;

export const BannerImage = styled(Image)`
    width: 100%;
`;

export const AboutProductBannerTitle = styled.h1`
    margin-bottom: ${rem(16)};
    text-transform: uppercase;
    ${FONTS.wide.medium.size44};
    line-height: ${rem(44)};
    color: ${COLORS.textLightPrimary};

    ${mediaQuery(
        { maxWidth: MAX_1365 },
        css`
            ${FONTS.wide.medium.size36};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: 100%;
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            ${FONTS.wide.medium.size32};
        `,
    )};
`;

export const BottomContainer = styled.div`
    width: 100%;
    gap: ${rem(20)};
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: 100%;
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            gap: ${rem(32)};
        `,
    )};
`;

export const SubText = styled.span`
    ${FONTS.compact.regular.size17};
    line-height: ${rem(24)};
    color: ${COLORS.textLightPrimary};
    white-space: pre-wrap;
`;

export const ReferralLinkButton = styled(MainButton)`
    ${paddingButtonStyles};
    ${buttonMobileStyles};
    ${zIndexStyles};
`;

export const NewLeadButton = styled(MainButton)`
    ${paddingButtonStyles};
    ${newLeadButtonStyles};
    ${zIndexStyles};

    &:hover {
        ${newLeadButtonStyles};
    }

    ${buttonMobileStyles};
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: ${rem(20)};
`;

export const SectionContainerGoBack = styled.section`
    width: 100%;
    position: relative;
    margin-bottom: ${rem(20)};
`;

export const LinkWrapperGoBack = styled.div`
    width: 100%;
    display: flex;
    cursor: pointer;
`;

export const SvgWrapper = styled.div`
    width: ${rem(24)};
    height: ${rem(24)};
    display: flex;
    align-items: center;
    justify-content: center;
`;
